import React from 'react';
import './About.css';

function AboutAislinn() {
  return (
    <section className="about" id="cofounder-aislinn">
      <div className="about-inner">
        <h2 className="section-title">Aislinn McCubbins</h2>

        <div className="about-layout">
          <div className="about-photo reveal">
            <div className="about-photo-placeholder" aria-hidden="true" />
            <div className="about-title-box">
              <span>Co-Founder</span>
              <span className="divider">|</span>
              <span>Chief Operating Officer</span>
              <span className="divider">|</span>
              <span>Scyla Creator</span>
              <span className="divider">|</span>
              <span>Connection-Layer Engineer</span>
            </div>
          </div>

          <div className="about-text reveal delay-1">

            <p className="lead">
              Aislinn McCubbins co-founded Nexus Concordat and serves as
              Chief Operating Officer. She is the creator of Scyla, the
              biology-native programming language and compiler that runs
              the entire substrate.
            </p>

            <p>
              Where Marjorie architected the neurochemical model, Aislinn
              built the language it speaks. Scyla is the substrate under
              every Nexus Concordat product: NeXus Aegis, NexusNeuro AI,
              and the Aether cascade all compile through her work. The
              biology-native primitives she designed are what makes
              pharmacokinetic attention mechanisms possible on real hardware.
            </p>

            <p>
              Her ongoing engineering work is the connection layer that
              bridges biological cascades to language models: the hybrid
              wing that lets a chemistry-conditioned cell speak through
              a transformer voice. That bridge is what turns the patents
              from paper into operational products.
            </p>

            <div className="about-credentials">
              <div className="credential-item">
                <span className="credential-label">Role</span>
                <span className="credential-value">Co-Founder &amp; Chief Operating Officer</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Signature Work</span>
                <span className="credential-value">Scyla &mdash; Biology-Native Programming Language</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Patents Co-Invented</span>
                <span className="credential-value">2 of the 4 USPTO Provisional Applications</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Focus</span>
                <span className="credential-value">Connection-Layer Engineering &mdash; Biology to Language Bridge</span>
              </div>
            </div>

            <div className="patent-tags">
              <span className="patent-tag">63/962,385</span>
              <span className="patent-tag">64/034,536</span>
            </div>

            <blockquote>
              "The substrate needed a language of its own. So I built one."
            </blockquote>

          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutAislinn;
